// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Styleguide_buttons__13qqt"};